module.exports = __webpack_public_path__ + "d0b5118afeee0bcd09d01274e3020388.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/slideshow_03_mobile.jpg
// module id = 654
// module chunks = 0